@if (property !== undefined && isBrowser) {
    <mat-card class="property-list-card">
        <mat-card-content>
            <app-property-gallery [images]="property?.images || []"></app-property-gallery>
            <div class="property-details">
                <div class="property-address">
                    <div>
                        <span class="property-address-title" ngSkipHydration>
                            {{property.displayName ?? property.propertyType | titlecase }} in {{property.address.city}}, {{property.address.state}}
                        </span>
                    </div>
                    <div>
                        @defer {
                            <app-share-button [propertyTitle]="getPropertyTitle()" [propertyUrl]="getPropertyUrl()" theme="light"></app-share-button>
                            <app-save-button
                                [propertyId]="property.id" 
                                [isLiked]="property.liked"
                                (likedChange)="property.liked = $event"
                                theme="light">
                            </app-save-button>
                        }
                    </div>
                </div>

                <div class="property-detail" ngSkipHydration>
                    <div class="icon-with-label">
                        <span class="material-symbols-outlined" matTooltip="Property Type">house</span> 
                        <span>{{ property.propertyType | titlecase }}</span>
                    </div>
                    
                    <div class="icon-with-label">
                        <span class="material-symbols-outlined" matTooltip="Square Footage">square_foot</span>
                        <span>{{ property.sizeSqft + ' ft²'}}</span>
                    </div>

                    <div class="icon-with-label">
                        <span class="material-symbols-outlined" matTooltip="Bedrooms">bed</span>
                        <span class="bedrooms-text">
                            {{ property.bedrooms || 'N/A' }}
                            <span class="sleeps-part" [attr.data-sleeps]="property.sleeps">
                                {{ property.sleeps ? ' (sleeps ' + property.sleeps + ')' : '' }}
                            </span>
                        </span>
                    </div>

                    <div class="icon-with-label">
                        <span class="material-symbols-outlined" matTooltip="Bathrooms">bathtub</span>
                        <span>
                            {{ property.bathrooms || 'N/A' }}
                            <span class="bathrooms-text"></span>
                        </span>
                    </div>
                </div>

                <div style="margin-bottom: 1em;">
                    <app-booking-request-button [propertyId]="property.id"></app-booking-request-button>
                </div>
                @if (property.cost) {
                    <div class="property-cost">{{ property.cost | currency }} per night</div>
                }
                <div class="property-description">
                    {{property.description}}
                </div>

                <app-property-amenity-view [inputProperty]="property"></app-property-amenity-view>

                <div class="property-row two-column-row">
                    <div class="property-map">
                        @if(isBrowser) {
                            <app-google-map [locations]="locations" [height]="getMapHeight()"></app-google-map>
                        } @else {
                            <div class="map-placeholder" [style.height]="mapHeight"></div>
                        }
                    </div>

                    <div class="property-date-section" #calendarSection>
                        <div class="property-availability">
                            @if (isBrowser) {
                                <app-property-calendar [propertyId]="property.id" style="width:100%"></app-property-calendar>
                            } @else {
                                <div style="height: 400px;">Loading Calendar...</div>
                            }
                        </div>
                    </div>
                </div>
                <div class="property-card-footer">
                    Property last updated on {{ property.updatedAt | date: 'EEEE, MMMM d, y, h:mm a' }}
                </div>
            </div>

        </mat-card-content>
        <div class="property-card-footer">
            <app-property-card-footer></app-property-card-footer>
        </div>
    </mat-card>

    <!-- 🔥 FULL-SCREEN IMAGE VIEWER MODAL -->
    <!-- <div class="image-viewer-overlay" *ngIf="showImageViewer">
        <div class="image-viewer-container">
            
            <button mat-icon-button class="close-button" (click)="closeImageViewer()">
                <mat-icon>close</mat-icon>
            </button>
            
            
            <div class="main-image-container">
                <img [src]="viewerImageUrl" 
                    [alt]="viewerImageDescription"
                    class="viewer-image" />
            </div>
            
            
            @if (property && property.images && property.images.length > 1) {
                <button class="nav-button prev" (click)="prevImage()">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button class="nav-button next" (click)="nextImage()">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            }
            
            
            @if (property && property.images && property.images.length > 1) {
                <div class="image-counter">
                    {{ currentImageIndex + 1 }} / {{ property.images.length }}
                </div>
            }
        </div>
    </div> -->
}